import { createAsyncThunk } from '@reduxjs/toolkit'
import { getGroups } from '@/services/vehicle/vehicle.service'

export const getGroupsThunk = createAsyncThunk('Groups/getGroups', async () => {
	return getGroups()
})
